import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
declare var $: any;
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  id: any;
  amount: any;
  report_id: any;
  response: any;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) {
    if (this.router.getCurrentNavigation().extras.state) {
      console.log("54", this.router.getCurrentNavigation().extras.state)
      this.amount = this.router.getCurrentNavigation().extras.state.amount;
      this.report_id = this.router.getCurrentNavigation().extras.state.report_id;
      console.log()
    }
  }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        this.id = params['id'];
        console.log("36 id", this.id)
      })
  }
  goToViewPage() {
    $('#successModal').modal('hide');
    // this.reportList= false;
    // this.lastsec= true;
    // this.cnsstable = false;
    if (this.id == 'cnss') {
      this.router.navigate(['/cnss-reportList']);
    } else {
      this.router.navigate(['/cnamgs-reportlist']);
    }
  }
  payment() {
    var data = {
      amount: this.amount,
      report_id: this.report_id,
      reference_id: ""
    }
    if (this.id == "cnss") {
      console.log("57", data)
      this.api.payment(data).pipe(first())
        .subscribe(res => {
            this.ngxUiLoaderService.stop();
            if (res.status == 200) {
              console.log("50", data)
              this.goToViewPage()
              this.snackBar.open(res.message, "OK", {
                duration: 5000,
              });
            } else {
              this.snackBar.open(res.message, "OK", {
                duration: 5000,
              });
            }
          },
          error => {
            this.ngxUiLoaderService.stop();
          });
    } else {
      console.log("77", data)
      this.api.paymentCnamgs(data).pipe(first())
        .subscribe(res => {
            this.ngxUiLoaderService.stop();
            if (res.status == 200) {
              console.log("50", data)
              this.goToViewPage()
              this.snackBar.open(res.message, "OK", {
                duration: 5000,
              });
            } else {
              this.snackBar.open(res.message, "OK", {
                duration: 5000,
              });
            }
          },
          error => {
            this.ngxUiLoaderService.stop();
          });
    }

  }
}
